export const LESS_THAN = 'less_than'
export const MORE_THAN = 'more_than'
export const DEACTIVATED = 'deactivated'
